import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Data Visualization',
  content: `
Pliable provides powerful data visualization tools to help you explore and present your data. Visualizations are built on top of the Semantic Layer, ensuring consistent and governed data across all views.

- **[Charts](/docs/charts)** — Build dynamic reports and visualizations using metrics and dimensions
- **[Dashboards](/docs/dashboards)** — Combine multiple analyses, pipeline data, and filters into a single view
`,
};

export default doc;
